import React from 'react';
import { Property } from '../../../types';
import { CurrencyDollarIcon } from '../../Icons';
import { PropertyTagsEditor } from '../property_edit/PropertyTagsEditor';

interface Props {
  formData: Partial<Property>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  onTagsChange?: (tags: string[]) => void;
}

export const CreatePropertySpecsFields: React.FC<Props> = ({ formData, onChange, onTagsChange }) => {
  const inputClass = 'mt-1 block w-full px-3 py-2 border-2 border-gray-100 rounded-xl text-xs font-bold focus:border-sky-500 outline-none transition-all appearance-none bg-white';
  const labelClass = 'text-[10px] font-black text-gray-500 uppercase tracking-wider mb-1 block';

  return (
    <div className="space-y-4">
      <div className="bg-sky-50/50 p-4 rounded-2xl border border-sky-100">
        <h4 className="text-xs font-black uppercase text-sky-900 flex items-center gap-2 mb-3">
          <CurrencyDollarIcon className="w-4 h-4 text-sky-600" />
          Precios & Estrato
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div>
            <label className={labelClass}>Precio de Venta ($ COP) *</label>
            <input type="number" name="precio_venta" value={formData.precio_venta ?? ''} onChange={onChange} className={inputClass} placeholder="0" required />
          </div>
          <div>
            <label className={labelClass}>Valor Administración ($ COP)</label>
            <input type="number" name="valor_administracion" value={formData.valor_administracion ?? ''} onChange={onChange} className={inputClass} placeholder="0" />
          </div>
          <div>
            <label className={labelClass}>Estrato</label>
            <select name="estrato" value={formData.estrato ?? 3} onChange={onChange} className={inputClass}>
              {[1, 2, 3, 4, 5, 6].map((e) => (<option key={e} value={e}>{e}</option>))}
            </select>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        <div>
          <label className={labelClass}>Habitaciones</label>
          <input type="number" min="0" name="num_habitaciones" value={formData.num_habitaciones ?? 0} onChange={onChange} className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Baños</label>
          <input type="number" min="0" name="num_banos" value={formData.num_banos ?? 0} onChange={onChange} className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Parqueaderos</label>
          <input type="number" min="0" name="num_parqueaderos" value={formData.num_parqueaderos ?? 0} onChange={onChange} className={inputClass} />
        </div>
        <div>
          <label className={labelClass}>Ascensores</label>
          <input
            type="number"
            min="0"
            name="ascensor"
            value={formData.ascensor ?? ''}
            onChange={onChange}
            className={inputClass}
            placeholder="0"
          />
        </div>
        <div className="col-span-2 sm:col-span-1 lg:col-span-1">
          <label className={labelClass}>Piso</label>
          <input type="text" name="piso" value={formData.piso || ''} onChange={onChange} className={inputClass} placeholder="Ej: 5" />
        </div>
      </div>

      <div>
        <label className={labelClass}>Descripción del Inmueble</label>
        <textarea
          name="descripcion"
          rows={3}
          value={formData.descripcion || ''}
          onChange={onChange}
          className={`${inputClass} resize-none`}
          placeholder="Escribe las bondades y detalles del inmueble..."
        />
      </div>

      {onTagsChange && (
        <PropertyTagsEditor
          tags={formData.tag || formData.tags || []}
          onChange={onTagsChange}
          idPrefix="create-property-tags"
        />
      )}
    </div>
  );
};
